<div class="file-upload-wrapper" [attr.dir]="isRtl ? 'rtl' : 'ltr'">
  <!-- OCR Loader Container -->

  <!-- Label -->
  @if (config.label) {
    <label [for]="inputId" class="gray_text main-label fs-14 d-block">
      {{ config.label || '' | translate }}
      @if (config.required) {
        <sup class="text-danger fs-12">*</sup>
      }
    </label>
  }
  <!-- Upload Container with Drag & Drop -->
  @if (!config.isExternalDragAndDrop) {
    <div
      class="upload-container form-control form-control rounded-1 text-muted fs-14 d-flex align-items-center justify-content-between"
      [class.drag-over]="isDragOver"
      [class.disabled]="isDisabled"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      (dragenter)="onDragEnter($event)"
    >
      <!-- File Preview (shown when file is selected or existing image exists) -->
      @if (hasFile) {
        <div class="d-flex align-items-center justify-content-between w-100 h-100">
          <!-- File Preview -->
          @if (config.showPreview) {
            <!-- PDF Preview -->
            @if (isPdfFile) {
              <img src="assets/icons/pdf.png" class="thumbnail-img" alt="PDF File" />
            } @else {
              <!-- Image Preview -->
              <img
                [src]="selectedFile ? displayImageUrl : (displayImageUrl | useHttpImgSrc: config.imageUrlParams)"
                class="thumbnail-img"
                alt="thumbnail-img"
                tabindex="0"
                (click)="openImageDialog(displayImageUrl)"
                (keydown.enter)="openImageDialog(displayImageUrl)"
                (keydown.space)="openImageDialog(displayImageUrl)"
              />
            }
          }

          <!-- File Name -->
          <span class="flex-grow-1 text-truncate ps-1 fs-14 fw-medium">
            {{ fileName }}
          </span>

          <!-- Remove Button -->
          <button
            type="button"
            class="border-0 bg-transparent delete-btn"
            (click)="removeSelectedFile()"
            [attr.aria-label]="'Remove file'"
          >
            <i class="das das-popup-delete"></i>
          </button>
        </div>
      }

      <!-- Upload Content (shown when no file is selected) -->
      @if (!hasFile) {
        <div class="upload-div text-muted fs-14 w-100 h-100 d-flex align-items-center justify-content-between">
          @if (isDragOver) {
            <div class="d-flex flex-column align-items-center justify-content-center w-100">
              <label [for]="inputId" class="d-flex flex-column align-items-center cursor-pointer">
                <i class="das das-new-upload fs-20 text-muted mb-2"></i>
                <span class="fs-14 text-muted fw-bold">{{ 'fileUpload.dropHere' | translate }}</span>
              </label>
            </div>
          } @else {
            <div class="d-flex align-items-center justify-content-between w-100">
              <div class="d-flex flex-column">
                <span class="pe-1 fs-14">
                  {{ config.placeholder || '' | translate }}
                </span>
              </div>
              <label [for]="inputId" class="icon-label">
                <i class="das das-new-upload fs-14 text-muted"></i>
              </label>
            </div>
          }
        </div>
      }

      <!-- Hidden File Input -->
      <input type="file" [id]="inputId" [accept]="config.acceptAttribute" (change)="onFileSelected($event)" hidden />
    </div>

    <!-- File Type Hint -->
    @if (config.showFileTypeHint) {
      <div class="mt-2 fs-12 text-muted">
        {{ config.fileTypeHintText || '' | translate }}
      </div>
    }

    <!-- Validation Messages -->
    <div>
      @if ((formControl?.touched || formControl?.dirty) && formControl?.errors) {
        <div class="text-danger fw-normal fs-12 pt-1">
          @if (formControl?.errors?.['required']) {
            <div>
              {{ config.validationMessages?.required || 'Image is required' | translate }}
            </div>
          }
          @if (formControl?.errors?.['invalidType']) {
            <div>
              {{ config.validationMessages?.invalidType || 'Invalid file type' | translate }}
            </div>
          }
          @if (formControl?.errors?.['maxSizeExceeded']) {
            <div>
              {{ config.validationMessages?.maxSizeExceeded || 'File size exceeds limit' | translate }}
            </div>
          }
        </div>
      }
    </div>
  }
</div>
@if (config.isExternalDragAndDrop) {
  <div class="fileupload-view">
    <div
      class="upload-container"
      [class.drag-over]="isDragOver"
      [class.disabled]="isDisabled"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      (dragenter)="onDragEnter($event)"
    >
      <div class="upload-box">
        <p class="gray_text">Choose a file or drag & drop it here</p>
        <small>JPEG, PNG, PDF, and MP4 formats, up to 50MB</small>
        <button class="btn btn-primary fw-bold fs-14 rounded-1" (click)="fileInput.click()">Browse File</button>
        <input type="file" #fileInput hidden (change)="onFileSelected($event)" [accept]="allowedTypes.join(',')" />
        <!-- Validation Messages -->
        @if ((formControl?.touched || formControl?.dirty) && formControl?.errors) {
          <div class="text-danger fw-normal fs-12 pt-1">
            @if (formControl?.errors?.['required']) {
              <div>
                {{ config.validationMessages?.required || 'Image is required' | translate }}
              </div>
            }
            @if (formControl?.errors?.['invalidType']) {
              <div>
                {{ config.validationMessages?.invalidType || 'Invalid file type' | translate }}
              </div>
            }
            @if (formControl?.errors?.['maxSizeExceeded']) {
              <div>
                {{ config.validationMessages?.maxSizeExceeded || 'File size exceeds limit' | translate }}
              </div>
            }
          </div>
        }
      </div>
    </div>

    <!-- Show preview if file is selected -->
    @if (hasFile) {
      <div class="preview-container">
        <div class="preview-card">
          @if (config.showOcrLoader) {
            <div #ocrLoaderContainer class="ocr-loader"></div>
          }
          @if (!isPdfFile) {
            @if (displayImageUrl) {
              <img
                [src]="selectedFile ? displayImageUrl : (displayImageUrl | useHttpImgSrc: config.imageUrlParams)"
                alt="Preview"
                tabindex="0"
                role="button"
                (click)="openImageDialog(displayImageUrl)"
                (keydown.enter)="openImageDialog(displayImageUrl)"
                (keydown.space)="openImageDialog(displayImageUrl)"
              />
            }
          } @else {
            <div
              class="pdf-preview"
              tabindex="0"
              role="button"
              (click)="onPdfIconClick()"
              (keydown.enter)="onPdfIconClick()"
              (keydown.space)="onPdfIconClick()"
            ></div>
          }

          <button
            type="button"
            class="border-0 bg-transparent delete-btn"
            (click)="removeSelectedFile()"
            [attr.aria-label]="'Remove file'"
          >
            <i class="das das-popup-delete"></i>
          </button>
        </div>
      </div>
    }
  </div>
}
